import { render, staticRenderFns } from "./SwitchTeamMemberModal.vue?vue&type=template&id=d4cf0572&scoped=true&"
import script from "./SwitchTeamMemberModal.vue?vue&type=script&lang=js&"
export * from "./SwitchTeamMemberModal.vue?vue&type=script&lang=js&"
import style0 from "./SwitchTeamMemberModal.vue?vue&type=style&index=0&id=d4cf0572&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4cf0572",
  null
  
)

export default component.exports